const { getElement } = window.BAO.Utils

class FormValidation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.formDisabled = false
    this.checkRequiredState()
  }

  setupListeners () {
    super.setupListeners()

    if (this?.els?.required?.exists && this?.els?.submit?.exists) {
      this.els.required.elements.forEach(requiredEl => {
        this.listeners.add(
          requiredEl,
          'input',
          this.checkRequiredState.bind(this),
        )
      })
    }

    this.handleMaidenNameInput = this.handleMaidenNameInput.bind(this)
    if (this?.els?.maidenNameInput?.exists) {
      this?.els?.maidenNameInput?.elements.forEach(input => {
        input.addEventListener('input', this.handleMaidenNameInput)
      })
    }
  }

  handleMaidenNameInput (e) {
    const inputValue = e.target?.value
    if (inputValue && inputValue.length > 0) {
      this.disableForm()
    }
  }

  disableForm () {
    this.formDisabled = true

    // Disable submit
    if (this?.els?.submit?.exists) {
      this.els.submit.element.ariaDisabled = true
      this.els.submit.element.disabled = true
    }

    // Disable form and prevent submit event
    const form = getElement('form', {
      context: this,
    })
    if (form) {
      form.setAttribute('disabled', 'disabled')
      form.addEventListener('submit', e => {
        e.preventDefault()
      })
    }
  }

  checkRequiredState () {
    if (this.formDisabled) return

    let allAreFilled = true

    this.els.required.elements.every(requiredEl => {
      if (requiredEl.type === 'text' && requiredEl.value.length === 0) {
        allAreFilled = false

        return false
      }

      if (requiredEl.type === 'email' && requiredEl.value.length === 0) {
        allAreFilled = false

        return false
      }

      if (requiredEl.type === 'password' && requiredEl.value.length === 0) {
        allAreFilled = false

        return false
      }

      if (requiredEl.type === 'checkbox' && requiredEl.checked !== true) {
        allAreFilled = false

        return false
      }

      return true
    })

    this.els.submit.element.ariaDisabled = !allAreFilled
  }
}

customElements.define('form-validation', FormValidation)
